declare let LCTranslations;
declare let referencesTranslations;
declare let countryTranslations;
declare let productsTranslations;
declare let translations;

export const translate = (key: string) => {
    if (typeof LCTranslations != "undefined" && LCTranslations[key]){
        return LCTranslations[key];
    }else if(typeof referencesTranslations != "undefined" && referencesTranslations[key]){
        return referencesTranslations[key];
    }else if(typeof countryTranslations != "undefined" && countryTranslations[key]){
        return countryTranslations[key];
    }else if(typeof productsTranslations != "undefined" && productsTranslations[key]){
        return productsTranslations[key];
    }else if(typeof translations != "undefined" && translations[key]){
        return translations[key];
    }else{
        return key;
    }
}

